import { IconType } from '@doordash/design-language';
import { ButtonSize } from './types.js';

var _SizeSemantics;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var ButtonIconType = IconType;
/**
 * IconTypes constant for use with IconButton component.
 * @exportedComponentConstant
 */

var IconButtonIconType = IconType;
/**
 * Size constant for use with IconButton component.
 * @exportedComponentConstant
 */

var SizeSemantics = (_SizeSemantics = {}, _defineProperty(_SizeSemantics, ButtonSize.Small, 'ButtonSmall'), _defineProperty(_SizeSemantics, ButtonSize.Medium, 'ButtonMedium'), _defineProperty(_SizeSemantics, ButtonSize.Large, 'ButtonLarge'), _defineProperty(_SizeSemantics, ButtonSize.XLarge, 'ButtonLarge'), _SizeSemantics);

export { ButtonIconType, IconButtonIconType, SizeSemantics };
